import React from 'react';
import styled from '@emotion/styled';
import { Link, Typography } from '@mui/material';

// Policy Wordings
import BroadformBuildingInsurancePolicy from '../assets/documents/products-key-information/commercial/Broadform-building-insurance-policy-2025.pdf';
import BroadformBuildingKeyInformationDocument from '../assets/documents/products-key-information/commercial/Broadform-building-KID-2025.pdf';
import CommunityLivingInsurancePolicy from '../assets/documents/products-key-information/community/Community-living-insurance-policy-2025.pdf';
import CommunityLivingKeyInformationDocument from '../assets/documents/products-key-information/community/Community-living-KID-2025.pdf';
import FidelityAndComputerCrimeInsurancePolicy from '../assets/documents/products-key-information/fidelity/Fidelity-Computer-Crime-insurance-policy-2025.pdf';
import SummaryOfChangesToFidelityComputerCrimePolicy from '../assets/documents/products-key-information/fidelity/Summary-of-Changes-to-Fidelity-Computer-Crime-Policy-November-2025.pdf';
import PrivacyPolicy from '../assets/documents/products-key-information/CIA-Privacy-Policy-03102025.pdf';
import BroadformHomeownersInsurancePolicy from '../assets/documents/products-key-information/homeowners/Broadform-homeowners-insurance-policy-2025.pdf';
import BroadformHomeownersKeyInformationDocument from '../assets/documents/products-key-information/homeowners/Broadform-homeowners-KID-2025.pdf';
import SasriaMaterialDamagePolicy from '../assets/documents/SASRIA Material-Damage-Policy-2026.pdf';
import SasriaMotorPolicy from '../assets/documents/SASRIA Motor-Policy-2026.pdf';

//Forms
import DeclarationByManagingAgentFidelityAndComputerCrimePolicyNewBusinessAndRenewals from '../assets/documents/products-key-information/fidelity/CIA-Fidelity-Computer-Crime-Declaration-ManagingAgent.pdf';
import FidelityComputerCrimeQuotationProposalForm from '../assets/documents/products-key-information/fidelity/Fidelity-And-Computer-Crime-Quotation-Proposal-Form.pdf';
import InsuranceProposalForm from '../assets/documents/products-key-information/CIA-Insurance-Proposal-Form-February-2026.pdf';
import BrokerApplicationForm from '../assets/documents/Broker-Application-Form.pdf';
import DebitOrderAuthorityForm from '../assets/documents/CIA-Debit-Order-Authority.pdf';
import CIAClaimForm from '../assets/documents/CIA-Claim-Form.pdf';
import CIAFastTrackGeyserClaimForm from '../assets/documents/CIA-Fast-Track-Geyser-Claim-Form.pdf';
import CIAFidelityComputerCrimeClaimForm from '../assets/documents/CIA-Fidelity-Computer-Crime-Claim-Form.pdf';
import CIAHotWorkPermit from '../assets/documents/CIA-Hot-Works-Permit-2023.pdf';
import CIAAlternativeEnergy from '../assets/documents/CIA-Alternative-Energy-November2025.pdf';
import FGRenewalForm from '../assets/documents/FG-Renewal-Form-2025.pdf';
import CIACreditCheckConsentForm from '../assets/documents/CIA-Consent-Credit-Check-Financial-Risk-Survey.pdf';

//Legal
import CIAObjectionRequestPOPIForm from '../assets/documents/legal/CIA-Objection-Request-POPI-Form.pdf';
import PromotionofAccesstoInformation from '../assets/documents/legal/PAIA-2025.pdf';
import CodeofConduct from '../assets/documents/legal/Code-of-Conduct.pdf';
import DisclosureNotice from '../assets/documents/legal/Disclosure-Notice-2025.pdf';
import TreatingCustomersFairly from '../assets/documents/legal/Treating-Customers-Fairly-2025.pdf';
import ConflictOfInterestManagementPolicy from '../assets/documents/legal/Conflict of Interest Management Policy Sept 2024.pdf';
import ComplaintsPolicy from '../assets/documents/legal/Complaints-Policy.pdf';

//Other
import AverageWaiverExtension from '../assets/documents/products-key-information/community/average-waiver-flyer-2026.pdf';
import EnhancedGeyserBenefit from '../assets/documents/products-key-information/community/Enhanced-Geyser-Benefit.pdf';
import GeyserBrochure from '../assets/documents/Geyser-Brochure-2024.pdf';
import CIABrochure from '../assets/documents/CIA-2024-Brochures.pdf';

const ItemLink = styled(Link)(({ theme }) => ({
    marginBottom: '20px',
}));

const LinkContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
}));

const PolicyWordingsSection = () => {
    return (
        <React.Fragment>
            <LinkContainer>
                <Typography variant="h5" marginBottom={1}>
                    Policy Wordings
                </Typography>
                <ItemLink
                    href={BroadformBuildingInsurancePolicy}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Broadform Building Insurance Policy
                </ItemLink>
                <ItemLink
                    href={BroadformBuildingKeyInformationDocument}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Broadform Building Key Information Document
                </ItemLink>
                <ItemLink
                    href={BroadformHomeownersInsurancePolicy}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Broadform Homeowners Insurance Policy
                </ItemLink>
                <ItemLink
                    href={BroadformHomeownersKeyInformationDocument}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Broadform Homeowners Key Information Document
                </ItemLink>
                <ItemLink
                    href={CommunityLivingInsurancePolicy}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Community Living Insurance Policy
                </ItemLink>
                <ItemLink
                    href={CommunityLivingKeyInformationDocument}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Community Living Key Information Document
                </ItemLink>
                <ItemLink
                    href={FidelityAndComputerCrimeInsurancePolicy}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Fidelity And Computer Crime Insurance Policy
                </ItemLink>
                <ItemLink
                    href={SummaryOfChangesToFidelityComputerCrimePolicy}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Summary Of Changes To Fidelity Computer Crime Policy
                </ItemLink>
                <ItemLink href={SasriaMaterialDamagePolicy} target="_blank">
                    SASRIA Material Damage Insurance Policy 2025
                </ItemLink>
                <ItemLink href={SasriaMotorPolicy} target="_blank">
                    SASRIA Motor Insurance Policy 2025
                </ItemLink>
            </LinkContainer>
        </React.Fragment>
    );
};

const FormsSection = () => {
    return (
        <React.Fragment>
            <LinkContainer>
                <Typography variant="h5" marginBottom={1} marginTop={3}>
                    Forms
                </Typography>
                <ItemLink href={BrokerApplicationForm} target="_blank" rel="noopener noreferrer">
                    Broker Application Form
                </ItemLink>
                <ItemLink href={CIAClaimForm} target="_blank" rel="noopener noreferrer">
                    CIA Claim Form
                </ItemLink>
                <ItemLink href={CIAAlternativeEnergy} target="_blank" rel="noopener noreferrer">
                    CIA ALTERNATIVE ENERGY
                </ItemLink>
                <ItemLink
                    href={CIAFastTrackGeyserClaimForm}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    CIA Fast Track Geyser Claim Form
                </ItemLink>
                <ItemLink
                    href={CIAFidelityComputerCrimeClaimForm}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    CIA Fidelity Claim Form
                </ItemLink>
                <ItemLink href={CIAHotWorkPermit} target="_blank" rel="noopener noreferrer">
                    CIA Hot Work Permit
                </ItemLink>
                <ItemLink href={InsuranceProposalForm} target="_blank" rel="noopener noreferrer">
                    CIA Insurance Proposal
                </ItemLink>
                <ItemLink
                    href={
                        DeclarationByManagingAgentFidelityAndComputerCrimePolicyNewBusinessAndRenewals
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Declaration By Managing Agent Fidelity And Computer Crime Policy New Business
                    And Renewals
                </ItemLink>
                <ItemLink
                    href={FidelityComputerCrimeQuotationProposalForm}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Fidelity Computer Crime Quotation Proposal Form
                </ItemLink>
                <ItemLink href={FGRenewalForm} target="_blank" rel="noopener noreferrer">
                    Fidelity And Computer Crime Renewal Form
                </ItemLink>
                <ItemLink href={DebitOrderAuthorityForm} target="_blank" rel="noopener noreferrer">
                    CIA Debit Order Authority Form
                </ItemLink>
                <ItemLink
                    href={CIACreditCheckConsentForm}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    CIA Credit Check Consent Form
                </ItemLink>
            </LinkContainer>
        </React.Fragment>
    );
};

const LegalSection = () => {
    return (
        <React.Fragment>
            <LinkContainer>
                <Typography variant="h5" marginBottom={1} marginTop={3}>
                    Legal
                </Typography>
                <ItemLink href={PrivacyPolicy} target="_blank" rel="noopener noreferrer">
                    CIA Privacy Policy
                </ItemLink>
                <ItemLink
                    href={CIAObjectionRequestPOPIForm}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    CIA Objection Request POPI Form
                </ItemLink>
                <ItemLink
                    href={PromotionofAccesstoInformation}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Promotion of Access to Information Policy
                </ItemLink>
                <ItemLink href={CodeofConduct} target="_blank" rel="noopener noreferrer">
                    Code of Conduct
                </ItemLink>
                <ItemLink href={DisclosureNotice} target="_blank" rel="noopener noreferrer">
                    Disclosure Notice
                </ItemLink>
                <ItemLink href={TreatingCustomersFairly} target="_blank" rel="noopener noreferrer">
                    Treating Customers Fairly
                </ItemLink>
                <ItemLink
                    href={ConflictOfInterestManagementPolicy}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Conflict of Interest Management Policy
                </ItemLink>
                <ItemLink href={ComplaintsPolicy} target="_blank" rel="noopener noreferrer">
                    Complaints Policy
                </ItemLink>
            </LinkContainer>
        </React.Fragment>
    );
};

const OtherSection = () => {
    return (
        <React.Fragment>
            <LinkContainer>
                <Typography variant="h5" marginBottom={1} marginTop={3}>
                    Other
                </Typography>
                <ItemLink href={AverageWaiverExtension} target="_blank" rel="noopener noreferrer">
                    Average Waiver Extension
                </ItemLink>
                <ItemLink href={CIABrochure} target="_blank" rel="noopener noreferrer">
                    CIA Brochure
                </ItemLink>
                <ItemLink href={EnhancedGeyserBenefit} target="_blank" rel="noopener noreferrer">
                    Enhanced Geyser Benefit
                </ItemLink>
                <ItemLink href={GeyserBrochure} target="_blank" rel="noopener noreferrer">
                    Geyser Brochure
                </ItemLink>
            </LinkContainer>
        </React.Fragment>
    );
};

export { PolicyWordingsSection, FormsSection, OtherSection, LegalSection };
